export enum TipoCondicionEnum { PAIS, GENERO, CONTESTO, TAG }
